import Model from './ModelCustomer'

export default class Item extends Model {
  resource()
  {
    return 'items'
  }
}